(() => {
  'use strict';

  const ROOT_SELECTOR = '.article-content.rte';
  const MIN_IMGS_IN_P = 2;

  // Layout
  const IPR_MOBILE = 1;
  const IPR_TABLET = 2;
  const IPR_DESKTOP = 2;

  // Autoplay
  const AUTOPLAY = true;

  function cleanEmptyImages(root) {
    root.querySelectorAll('img').forEach((img) => {
      const src = img.getAttribute('src');
      if (!src || src.trim() === '') img.remove();
    });
  }

  function cloneGridyArrows() {
    const tpl = document.getElementById('tpl-gridy-arrows');
    if (!tpl || !tpl.content) return null;
    if (tpl.content.firstElementChild) {
      return tpl.content.firstElementChild.cloneNode(true);
    }
    return tpl.content.cloneNode(true);
  }

 function buildGridySliderFromElements(elements) {
  const slider = document.createElement('gridy-slider');
  slider.className = 'gridy-slider blog-inline-slider';
  slider.dataset.mobileEnabled = 'true';
  slider.dataset.tabletEnabled = 'true';
  slider.dataset.desktopEnabled = 'true';
  slider.dataset.iprMobile = String(IPR_MOBILE);
  slider.dataset.iprTablet = String(IPR_TABLET);
  slider.dataset.iprDesktop = String(IPR_DESKTOP);
  slider.dataset.arrows = 'true';
  slider.dataset.slidingBehavior = 'single';
  slider.dataset.autoplay = AUTOPLAY ? 'true' : 'false';

  const track = document.createElement('div');
  track.className =
    'grid sm-gap gridy-track scrollbar--hide ' +
    'grid-cols-' + IPR_MOBILE + ' sm-grid-cols-' + IPR_TABLET + ' md-grid-cols-' + IPR_DESKTOP + ' ' +
    'track-inner-padding';

  elements.forEach((el) => {
    const fig = document.createElement('figure');
    fig.className = 'blog-inline-slide';
    fig.appendChild(el); // mantiene <a><img></a> o <img> così com'è
    track.appendChild(fig);
  });

  slider.appendChild(track);

  const arrows = cloneGridyArrows();
  if (arrows) slider.appendChild(arrows);

  return slider;
}
  function removeEmptyTextNodes(container) {
    Array.from(container.childNodes).forEach((n) => {
      if (n.nodeType !== Node.TEXT_NODE) return;
      const t = n.textContent.replace(/\u00A0/g, ' ').trim();
      if (t === '') n.remove();
    });
  }

function init() {
  const root = document.querySelector(ROOT_SELECTOR);
  if (!root) return;

  cleanEmptyImages(root);

  const ps = Array.from(root.querySelectorAll('p'));

  ps.forEach((p) => {
    if (p.querySelector('gridy-slider.blog-inline-slider')) return;
// Controlla se c'è uno span contenitore con le img dentro
  const span = p.querySelector(':scope > span');
  const container = span || p;
    // Raccogli figli diretti che siano IMG o A>IMG
    const slideElements = Array.from(p.childNodes).filter((node) => {
      // Salta text nodes e br
      if (node.nodeType === Node.TEXT_NODE) return false;
      if (node.tagName === 'BR') return false;

      if (node.tagName === 'IMG') {
        const src = node.getAttribute('src');
        return src && src.trim() !== '';
      }
      if (node.tagName === 'A') {
        const img = node.querySelector('img');
        if (!img) return false;
        const src = img.getAttribute('src');
        return src && src.trim() !== '';
      }
      return false;
    });

    if (slideElements.length < MIN_IMGS_IN_P) return;

    p.querySelectorAll('br').forEach((br) => br.remove());

    const slider = buildGridySliderFromElements(slideElements);
 // Inserisci lo slider al posto dello span (o come primo figlio del p)
  if (span) {
    p.replaceChild(slider, span);
  } else {
    p.insertBefore(slider, p.firstChild);
  }

    removeEmptyTextNodes(p);
  });
}

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
    window.addEventListener('load', init);
  } else {
    init();
    window.addEventListener('load', init);
  }

})();